export const iconFontAwesomeReligionHamsa = (
	<i className="fa-solid fa-hamsa"></i>
);
